<template>
  <div class="search-part">
    <div class="top">
      <span>{{ type === 'history' ? 'Recently Search' : 'Hot Search' }}</span>
      <i v-show="type === 'history'" class="iconfont icon-shanchu1" @click="deleteAll"></i>
    </div>
    <ul class="word-box">
      <li
        v-for="(item, i) of searchList"
        :key="i"
        :class="{ active: i === activeIdx }"
        @mouseenter="activeIdx = i"
        @click="toSearch(searchList[activeIdx].keywords)"
      >
        <i v-show="type === 'hot' && item.is_icon === 1" class="iconfont icon-a-redu1 i-left"></i>
        <span>{{ item.keywords }}</span>
        <i
          v-show="type === 'history'"
          class="iconfont icon-guanbi i-right"
          @click.stop="deleteHistory(item.keywords, i)"
        ></i>
      </li>
    </ul>
    <div class="btm">
      <p v-if="goodsList.length === 0" class="no-goods">
        Sorry, your search for '{{ searchList[activeIdx] ? searchList[activeIdx].keywords : '' }}'
        did not match any products.
      </p>
      <div v-if="goodsList.length" class="goods-swiper-wrap">
        <Swiper
          :key="'search-goods-' + activeIdx"
          class="goods-swiper"
          slidesPerView="auto"
          :spaceBetween="8"
          :allowTouchMove="false"
          :watchOverflow="true"
        >
          <SwiperSlide
            v-for="item of goodsList"
            :key="item.id"
            class="goods-slide"
            @click="
              tapGoods(item);
              sdSearchPageProductBtnClick({
                search_type: type === 'hot' ? 'Hot Search' : 'Recently Search',
                business_sku: item.business_sku,
                shop_sku: item.shop_sku,
                product_sku: item.sku,
                product_id: `${item.id}`,
                product_name: item.short_name,
              });
            "
          >
            <ProductCardSimple :product="item" showShortName />
          </SwiperSlide>
        </Swiper>
      </div>
      <p
        v-if="goodsList.length == 5"
        class="more"
        @click="toSearch(searchList[activeIdx].keywords)"
      >
        View<br />
        More
      </p>
    </div>
  </div>
</template>

<script>
import { useStore } from '@/store';
import { mapState } from 'pinia';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'SearchPart',
  components: {
    Swiper,
    SwiperSlide,
    ProductCardSimple: defineAsyncComponent(
      () => import('@/components/public/product-card/ProductCardSimple.vue'),
    ),
  },
  props: {
    type: {
      // history 最近浏览 hot 热搜
      type: String,
      default: 'history',
    },
    searchList: {
      type: Array,
      required: true,
    },
    // 是否有最近搜索
    hasRecently: {
      type: Boolean,
      default: true,
    },
    sdSearchPageProductBtnClick: {
      type: Function,
      default: () => () => {},
    },
  },
  emits: ['update:searchList', 'innerClick', 'search'],
  data() {
    return {
      activeIdx: 0,
    };
  },
  computed: {
    ...mapState(useStore, ['currency']),
    goodsList() {
      let list = [];
      try {
        list = this.searchList[this.activeIdx]?.products || [];
        list = list.slice(0, 5);
      } catch (error) {
        console.log(error);
      }
      return list;
    },
  },
  methods: {
    toSearch(keywords) {
      this.SDSearchBtnClick(this.type === 'history' ? 'Recently Search' : 'Hot Search', keywords);
      this.$router[this.$route.name === 'search' ? 'replace' : 'push']({
        path: '/result',
        query: {
          keywords,
          search_type: this.type === 'history' ? 2 : 4,
        },
      });
      this.$emit('search');
    },
    tapGoods(item) {
      try {
        const keywords = this.searchList[this.activeIdx]?.keywords;
        if (keywords) {
          console.log('tapGoods', keywords);
          this.$api.search.searchRecord({
            keywords,
            search_type: this.type === 'history' ? 2 : 4,
          });
        }
      } catch (error) {
        console.log(error);
      }
      sessionStorage.setItem('voo-DMP_pageType', 7);
      this.$router.push(`/goods-detail/${item.id}`);
    },
    deleteHistory(keywords, i) {
      let searchHistory = JSON.parse(localStorage.getItem('voo-searchHistory')) || [];
      searchHistory = searchHistory.filter((item) => !!item);
      if (searchHistory.indexOf(keywords) > -1) {
        const idx = searchHistory.indexOf(keywords);
        searchHistory.splice(idx, 1);
        searchHistory = searchHistory.filter((item) => !!item);
        localStorage.setItem('voo-searchHistory', JSON.stringify(searchHistory));

        const newList = this.searchList.filter((item, i) => i !== idx);
        this.$emit('update:searchList', newList);
        console.log(keywords, i, this.activeIdx);
        if (i === this.activeIdx) {
          this.activeIdx = 0;
        }
      }
      this.$emit('innerClick');
    },
    deleteAll() {
      localStorage.setItem('voo-searchHistory', JSON.stringify([]));
      this.$emit('update:searchList', []);
    },
    /**
     * @TrackType sensorsdata
     * @EventType SearchBtn_Click
     * @EventDesc 点击“搜索”
     * @EventParams {
     *  search_type: 搜索类型,
     *  search_text: 搜索词,
     * }
     * @Tapd 1009440
     */
    SDSearchBtnClick(search_type, search_text) {
      try {
        const sdEventName = 'SearchBtn_Click';
        const sdEventParams = {
          search_type,
          search_text,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-part {
  // width: 488px;
  .top {
    margin-top: 18px;
    span {
      font-size: 16px;
      font-family: $f-pb;
    }
    i {
      margin-left: 10px;
      font-size: 20px;
      color: #080506;
      cursor: pointer;
    }
  }
  .word-box {
    margin-top: 18px;

    @include flex($wrap: wrap);
    li {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 0 8px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px;
      background: #f7f5f2;
      cursor: pointer;
      &.active {
        color: #c23000;
        background: #fef5ec;
        .icon-guanbi {
          color: #c23000;
        }
      }
      .i-left {
        margin-right: 6px;
        color: $origin;
      }
      .i-right {
        margin-left: 6px;
        font-size: 12px;
        color: #5a544e;
      }
    }
  }
  .btm {
    margin-top: 12px;

    @include flex(space-between, stretch);
    .no-goods {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 14px;
      color: #908b7f;
    }
    .goods-swiper-wrap {
      flex: 1;
      min-width: 0;
    }
    .goods-swiper {
      overflow: hidden;
      margin-bottom: 0;
      cursor: default;
      :deep(.swiper-wrapper) {
        align-items: stretch;
      }
    }
    .goods-slide {
      width: 136px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .more {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 8px;
      padding: 0 10px;
      border-radius: 4px;
      color: #5a544e;
      background: #f7f5f2;
      flex: 0 0 auto;
      align-self: stretch;
      cursor: pointer;
    }
  }
}
</style>
